import React from "react";
import {Col, ControlLabel, FormControl, FormGroup, Row} from "react-bootstrap";
import {Consumer} from "./CreateSigntask";
import { useTranslation } from 'react-i18next';

const Signer =  ({prefix, signer, updateSigner}) => {
  const { t } = useTranslation();

  return(
    <React.Fragment>
      <Row>
        <Col componentClass={FormGroup} sm={6}>
          <ControlLabel>{t("create_signtask_signer_name")}</ControlLabel>
          <FormControl type="text" name={`${prefix}.Name`}
                      placeholder={t("create_signtask_signer_name_placeholder")} value={signer.name}
                      onChange={event => updateSigner({...signer, name: event.target.value})} />
        </Col>
        <Col componentClass={FormGroup} sm={6}>
          <ControlLabel>{t("create_signtask_signer_ssn")}</ControlLabel>
          <FormControl type="text" name={`${prefix}.Ssn`}
                      placeholder={t("create_signtask_signer_ssn_placeholder")} value={signer.ssn}
                      onChange={event => updateSigner({...signer, ssn: event.target.value})} />
        </Col>
      </Row>
      <Row>
        <Col componentClass={FormGroup} sm={6}>
          <ControlLabel>{t("create_signtask_signer_email")}</ControlLabel>
          <FormControl type="text" name={`${prefix}.Email`}
                      placeholder={t("create_signtask_signer_email_placeholder")} value={signer.email}
                      onChange={event => updateSigner({...signer, email: event.target.value})} />
        </Col>
        <Col componentClass={FormGroup} sm={6}>
          <ControlLabel>{t("create_signtask_signer_mobile")}</ControlLabel>
          <FormControl type="text" name={`${prefix}.Phone`}
                      placeholder={t("create_signtask_signer_mobile_placeholder")} value={signer.phone}
                      onChange={event => updateSigner({...signer, phone: event.target.value})} />
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default ({idx, ...props}) => (
  <Consumer>{({signers, updateSigner}) => (
    <Signer
      {...props}
      prefix={`signers[${idx}]`}
      signer={signers[idx]}
      updateSigner={updateSigner(idx)} />
  )}</Consumer>
);